
import * as Sentry from "@sentry/vue";

export const initSentry = (app) => {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
  });
}
